import React, { useState, useEffect } from "react";
import { useGetMatches } from "../api/matchesApi";
import { MatchesList } from "../components/matches/MatchesList";
import { MatchFilters } from "../components/matches/MatchFilters";
import "../styles/matches-page.css";

/**
 * Page component for displaying matches with pagination and filters
 * @returns {JSX.Element} - Matches page component
 */
export const MatchesPage = () => {
  // State for filters
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    status: "",
    teamId: "",
    sort: "-date" // Default sort: newest first
  });
  
  // Fetch matches data
  const { 
    data, 
    isLoading, 
    error, 
    refetch 
  } = useGetMatches(filters);
  
  // Refetch when filters change
  useEffect(() => {
    refetch();
  }, [filters, refetch]);
  
  // Handle page change
  const handlePageChange = (newPage) => {
    setFilters(prev => ({...prev, page: newPage}));
    // Scroll to top when page changes
    window.scrollTo(0, 0);
  };
  
  return (
    <div className="page-matches">
      <div className="wrapper">
        <div className="title-block">
          <h1>Matches</h1>
          <p>View all matches with filtering and pagination</p>
        </div>
        
        <MatchFilters 
          filters={filters} 
          setFilters={setFilters} 
        />
        
        <MatchesList 
          matches={data?.matches || []} 
          pagination={data?.pagination} 
          onPageChange={handlePageChange}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </div>
  );
};
